export default __webpack_public_path__ + "static/media/kausi14-min.b00a1bc6.jpg";